import React, { useEffect, useLayoutEffect, useMemo, useState } from "react";
import { MENU_ITEMS } from "constants";
import MenuItem from "./MenuItem";
import { MenuList } from "./styles";
import useUser from "hooks/useUser";
import http from "services/httpService";
import { isPathStrictlyV1, userHasViewPermission } from "utlis/utils";

function Menu() {
  const { getRole } = useUser();
  const [featureDetails, setFeatureDetails] = useState();
  const companyName = localStorage.getItem("company_name")
  const featureDetailsInCache = JSON.parse(localStorage.getItem("featureDetails"))
  
  const permissions = useMemo(() => {
    if(!featureDetails && !featureDetailsInCache) return null;
    let usefeatureDetails = featureDetails ? featureDetails : featureDetailsInCache
    return {
      claims: usefeatureDetails?.show_claim_summary,
      collection_history: usefeatureDetails?.collection_allowed
    }
  }, [featureDetails])

  useLayoutEffect(() => {
    if (!JSON.parse(localStorage.getItem("login_profile"))?.is_multiple_company_mapped && isPathStrictlyV1()) {
      getFeatureList();
    }
  }, [companyName])

  const getFeatureList = async () => {
    const { data } = await http.get("/business/get_company_product_details/");
    localStorage.setItem("featureDetails", JSON.stringify(data))
    setFeatureDetails(data);
  }

  const endsWithV1Profile = (path) => {
    const regex = /v1\/profile\/?$/;
    const changePassRegex = /\/v1\/profile\/change-password\/?$/;
    const result = regex.test(path) || changePassRegex.test(path)
    return result;
  };

  const permittedRoutes = useMemo(() => {
    return MENU_ITEMS.filter((item) => {
      const role = getRole();
      switch(item.path) {
        case "/v1/data-collection-history":
          return permissions?.collection_history || false;
        case "/v1/data-collection-history/collect":
          return permissions?.collection_history || false;
        case "/v1/claims":
          return permissions?.claims || false;
      }
      if (item.role) {
        return item.role == role;
      }
      return true;
    });
  }, [featureDetails]);

  const excludedLinks = ["Wellness"];

  const menuItems = () => {

    let fullUrl = window.location.pathname;
    const regex = /^\/v1\/?$/;

    if (userHasViewPermission() && regex.test(fullUrl) || endsWithV1Profile(fullUrl)) {
      return null;
    } else {
      return (
        <>
          <MenuList>
            {permittedRoutes
              .filter((item) => !excludedLinks.includes(item.name))
              .map(({ name, path, subPaths }) => (
                <MenuItem key={name} path={path} subPaths={subPaths}>
                  {name}
                </MenuItem>
              ))}
          </MenuList>
        </>
      );
    }
  };

  return (
    <>
      {menuItems()}
    </>
  );
}

export default Menu;
